import { ResponseMessage } from '@sdbn/appclient';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';
import { Component, Inject, OnDestroy } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { TransportOption, TransportOptionColumn, TransportOptionSelection, TransportOptionsPanelModel } from 'src/tmc-yard/components/transport-options-panel/transport-options-panel.model';
import { YardConfiguration } from 'src/tmc-yard/client/model/yard-configuration';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { FormControl, FormControlName, FormGroup } from '@angular/forms';

export class TransportOptionSelectionDialogData {
  carrier: string;
  driver: string;
  identifier: string;
  transportScope: any;
  responseMessages: ResponseMessage[];
}


@Component({
  selector: 'app-transport-option-selection',
  templateUrl: './transport-option-selection.component.html',
  styleUrls: ['./transport-option-selection.component.scss']
})
export class TransportOptionSelectionComponent implements OnDestroy {

  model: TransportOptionsPanelModel;
  validStateSubscription: Subscription;
  selectionChangeSubscription: Subscription;


  tmcContextSubscription: Subscription;
  yardConfiguration: YardConfiguration;

  selectedOptionIds = new Array<number>();

  isConfirmDisabled = true;

  vehicleFormGroup = new FormGroup({
    useAsVehicle: new FormControl(null, [])
  })

  constructor(
    public dialogRef: MatDialogRef<TransportOptionSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TransportOptionSelectionDialogData,
    public dialog: MatDialog,
    public translationService: TranslationService,
    private tmcContextService: TmcContextService
  ) {

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        this.yardConfiguration = next;
        this.createTransportOptionsModel();
      }
    });
  }

  ngOnDestroy() {
    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
      this.validStateSubscription = null;
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
      this.selectionChangeSubscription = null;
    }
    if (this.tmcContextSubscription != null) {
      this.tmcContextSubscription.unsubscribe();
      this.tmcContextSubscription = null;
    }
  }

  public cancelDialog() {
    this.dialogRef.close(null);
  }

  public confirm() {
    this.dialogRef.close({ selectedOptionIds: this.selectedOptionIds, asVehicle: this.vehicleFormGroup.controls['useAsVehicle'].value });
  }

  private createTransportOptionsModel() {

    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
    }

    if (this.yardConfiguration != null) {
      let columns = new Array<TransportOptionColumn>();
      for (let option of this.yardConfiguration.transportOptions) {
        while (option.columnIndex != null && columns.length < option.columnIndex + 1) {
          let column = new TransportOptionColumn();
          columns.push(column);
        }
        let column = columns[option.columnIndex];
        column.options.push(new TransportOption(option));
      }

      this.model = new TransportOptionsPanelModel(
        {
          columns: columns,
          constraints: this.yardConfiguration.transportOptionConstraints,
          selection: new Array<TransportOptionSelection>()
        }
      );
      this.validStateSubscription = this.model.validState.subscribe(valid => {
        this.updateEnablement();
      });

      this.selectionChangeSubscription = this.model.selectionChange.subscribe(value => {

        const newSelection = new Array<number>();
        for (const selection of this.model.getOnlySelectedTransportOptionSelection()) {
          newSelection.push(selection.transportOptionId);
        }
        this.selectedOptionIds = newSelection;
      });
    }
  }

  private updateEnablement() {
    this.isConfirmDisabled = !this.model.valid;
  }
}
